import { Injectable } from "@angular/core";
import { BehaviorSubject, take } from "rxjs";
import { PizzaLasanhaGrid } from "src/app/pages/integracao/grid-pizzas-lasanhas/pizza-lasanha-grid.viewmodel";
import { GrupoIntegracaoViewModel, ProdutoComEmpresaView, ProdutosIntegracaoResponse } from "src/app/shared/models/produto.model";
import { CastModelUtils } from "src/app/shared/utils/CastModelUtils";

@Injectable({
    providedIn: 'root'
})
export class ProdutoIntegracaoService {
    public produtosIntegracao = new BehaviorSubject<ProdutoComEmpresaView[]>(null);
    public gruposIntegracao = new BehaviorSubject<GrupoIntegracaoViewModel[]>(null);

    public alterarStatus(codigoProduto: number, ativo: boolean) {
        let produtos: ProdutoComEmpresaView[] = [];

        this.produtosIntegracao.pipe(take(1)).subscribe((res) => {
            produtos = res;
            
            produtos = produtos.map((produto) => {    
                if (produto.codigo === codigoProduto) {
                    produto.checked = ativo
                }

                return CastModelUtils.ClonarObjetoComPropriedadesIguais(produto, new ProdutoComEmpresaView());
            });
    
            this.produtosIntegracao.next(produtos);
        })
    }
}